/** Equirectangular meter-per-degree constants, accurate at NYC latitudes.
 * Shared by the layer animators so straight-line distances/steps stay in sync. */
export const M_PER_DEG_LAT = 111_000;
export const M_PER_DEG_LNG = 84_000; // ~cos(40.7°) · 111_000

/** Straight-line distance (m) between two [lng,lat] points (equirect approx). */
export function metersBetween(a: [number, number], b: [number, number]): number {
  const dx = (b[0] - a[0]) * M_PER_DEG_LNG;
  const dy = (b[1] - a[1]) * M_PER_DEG_LAT;
  return Math.hypot(dx, dy);
}
